import { Reveal } from "./Reveal";

const SectionHead = ({ overline, title, lead, dark = false, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <p className={`font-mono text-xs uppercase tracking-[0.25em] mb-5 ${dark ? "text-accent-bright" : "text-accent"}`} data-testid="section-overline">
      {overline}
    </p>
    <h2 className={`font-serif font-light tracking-tight leading-[1.08] text-3xl sm:text-4xl lg:text-5xl ${dark ? "text-paper" : "text-ink"}`}>
      {title}
    </h2>
    {lead && (
      <p className={`mt-6 text-base sm:text-lg leading-relaxed ${dark ? "text-white/70" : "text-mutedink"}`}>
        {lead}
      </p>
    )}
  </Reveal>
);

export default SectionHead;
